import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  FormGroup,
  Input,
  Label
} from "reactstrap"
import Loading from 'lib/loading'
import './style.css'

const Permissoes = (lista) => {
  const [loading, setLoading] = useState(true)
  const [isOpen, setIsOpen]   = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const AcessoPerfil = () => {

    if (lista.lista.length > 0) {
      const controles = lista.lista.map((controle, index) => {
        if (controle.itens && controle.itens !='') {
          return (
            <div className="card-2 mt-4 w-100" key={index} >
              <Col md='12'>
                <span className="tag-card"><b>{controle.nome}</b></span>
                <Row>
                  {
                    controle.itens.map((item, indexI) =>
                      <Col className="p-0" md="2" key={index+item.controle_item_id+indexI}>
                        <FormGroup className="m-2" check>
                          <Label style={{paddingLeft: '30px'}} check>
                            <Input
                              type    = "checkbox"
                              id      = {"controleItem" + item.controle_item_id}
                              key     = {"controleItem" + item.controle_item_id}
                              name    = {item.nome}
                              label   = {item.nome}
                              checked = {true}
                              disabled
                            />
                            <span className="form-check-sign" />{item.nome}
                          </Label>
                        </FormGroup>
                      </Col>
                    )
                  }
                </Row>
              </Col>
            </div>
          )
        } else {
          return (
            <div className="card-2 mt-4 w-100" key={index}>
              <Col md='12'>
                <span className="tag-card"><b>{controle.nome}</b></span>
                <Row>
                  <Col className="p-0" md="2">
                    <FormGroup className="m-2" check>
                      <Label style={{paddingLeft: '30px'}} check>
                        <Input
                          type    = "checkbox"
                          id      = {"controle" + controle.controle_id}
                          key     = {"controle" + controle.controle_id}
                          name    = {controle.nome}
                          label   = {controle.nome}
                          checked = {true}
                          disabled
                        />
                        <span className="form-check-sign" />{controle.nome}
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </div>
          )
        }
      })

      setLoading(false)
      return (controles)
    }else {
      setLoading(false)
      return (<span className="nenhumPerfil">Nenhum perfil selecionado...</span>)
    }
  }

  useEffect(()=>{
    setLoading(false)
  },lista)

  if (loading) {
    return (
      <>
      <Row>
        <Loading tipo='componente' />
      </Row>
      </>
    )
  }else {
    return (
      <Row>
        <AcessoPerfil/>
      </Row>
    )
  }
}

export default Permissoes
